var exports = {
  "k": "x93eb46d8--511d13--container",
};

module.exports = exports;
